import { memo, useCallback } from 'react'

import { getLabelByExternalField } from 'clickNgo/entities/partner/libs/helpers'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { contactEditorTranslation } from '../../translation'

import { IMenuLabelWithInfoProps } from './models'

import styles from './MenuLabelWithInfo.module.scss'

export const MenuLabelWithInfo = memo<IMenuLabelWithInfoProps>(
  ({ title, status, modifiedValues = [] }) => {
    const tooltipContent = useCallback(
      () => (
        <>
          <div style={{ display: 'flex' }}>{status}:</div>{' '}
          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              alignItems: 'flex-start',
              paddingTop: 4,
            }}
          >
            {modifiedValues?.map(getLabelByExternalField).map((label) => (
              <li key={label}>
                <Translation text={label as string} span />
              </li>
            ))}
          </ul>
        </>
      ),
      [modifiedValues, status]
    )

    if (status) {
      return (
        <div className={styles.container}>
          <Translation text={title} />
          <Tooltip tipContent={tooltipContent}>
            <span className={styles.status}>
              <Translation text={contactEditorTranslation.other.menuStatus} />{' '}
              <span className={styles.statusText}>{status}</span>
            </span>
          </Tooltip>
        </div>
      )
    }

    return <Translation text={title} />
  }
)

MenuLabelWithInfo.displayName = 'MenuLabelWithInfo'
